var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecurityWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 2C13.1411 3.89436 15.9357 4.88069 18.7916 4.75C19.2074 6.16443 19.3346 7.64801 19.1657 9.11258C18.9968 10.5772 18.5352 11.9928 17.8084 13.2755C17.0815 14.5581 16.1043 15.6816 14.9347 16.5791C13.7651 17.4766 12.427 18.1299 10.9999 18.5C9.57287 18.1299 8.23479 17.4766 7.06518 16.5791C5.89557 15.6816 4.91831 14.5581 4.19148 13.2755C3.46464 11.9928 3.00305 10.5772 2.83415 9.11258C2.66525 7.64801 2.79247 6.16443 3.20826 4.75C6.06416 4.88069 8.85875 3.89436 10.9999 2",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 10.8333C11.5062 10.8333 11.9166 10.4229 11.9166 9.91667C11.9166 9.41041 11.5062 9 10.9999 9C10.4937 9 10.0833 9.41041 10.0833 9.91667C10.0833 10.4229 10.4937 10.8333 10.9999 10.8333Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11V13.2917",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityWhite);
export default __webpack_public_path__ + "static/media/Icon_Security_White.e9f0cf6f6cb0db7a93897d3e079562ea.svg";
export { ForwardRef as ReactComponent };